import { IProfessionalProfile } from 'app/interfaces/professionalprofile.interface';

export enum ModalSteps {
	update50MinPrice = 'UPDATE_50_MIN_PRICE',
	update30MinPrice = 'UPDATE_30_MIN_PRICE',
	confirm30MinPrice = 'CONFIRM_30_MIN_PRICE',
	confirm50MinPrice = 'CONFIRM_50_MIN_PRICE',
}

export interface UpdateSessionPrice {
	priceOneHour?: IProfessionalProfile['priceOneHour'];
	priceHalfHour?: IProfessionalProfile['priceHalfHour'];
}
